import axios from "axios";

// Base configuration for Axios instance
const API_BASE_URL = "https://localhost:3000";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Fetch Puja data
export const fetchPuja = async (searchParam = "", puja_category_id) => {
  try {
    const response = await api.post(`/v1/apiselectall`, {
      searchParam,
      puja_category_id,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Puja data:", error);
    throw error;
  }
};

// Fetch Puja details by ID
export const fetchPujaDetails = async (puja_category_id) => {
  try {
    const response = await api.post(`/v1/apiselect`, { puja_category_id });
    return response.data;
  } catch (error) {
    console.error("Error fetching Puja details:", error);
    throw error;
  }
};

// Add a new Puja
export const addPuja = async (pujaData) => {
  try {
    // Ensure `pujaData` includes the correct file format for the image
    const formData = new FormData();
    for (const key in pujaData) {
      formData.append(key, pujaData[key]);
    }

    // Make the POST request
    const response = await api.post(`/v1/apiinsert`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error adding Puja:", error);
    throw error;
  }
};

// Update Puja details
export const updatePuja = async (puja_category_id, updatedData) => {
  try {
    // Ensure `updatedData` includes the correct file format for the image (if any)
    const formData = new FormData();
    formData.append("puja_category_id", puja_category_id);
    for (const key in updatedData) {
      formData.append(key, updatedData[key]);
    }

    // Make the POST request with `multipart/form-data` headers
    const response = await api.post(`/v1/apiupdate`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating Puja data:", error);
    throw error;
  }
};

// Delete Puja
export const deletePuja = async (puja_category_id) => {
  try {
    const response = await api.post(`/v1/apidelete`, { puja_category_id });
    return response.data;
  } catch (error) {
    console.error("Error deleting Puja:", error);
    throw error;
  }
};
